import { render } from "./ItBeratungDetails.vue?vue&type=template&id=aba88f4a"
import script from "./ItBeratungDetails.vue?vue&type=script&lang=js"
export * from "./ItBeratungDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__